import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { IntroContent } from './IntroContent';
import { KeyHighlights } from './KeyHighlights';
import { CourseLength } from './CourseLength';
import { CoursePrerequisites } from './CoursePrerequisites';
import { CourseOverview } from './CourseOverview';
import { RegistrationCallout } from './RegistrationCallout';
import { CourseCosts } from './CourseCosts';
import { WhatToBring } from './WhatToBring';
import { RegistrationLinks } from './RegistrationLinks';
import { ContactSection } from './ContactSection';
import { QuickLinks } from './QuickLinks';
export function CPLRenewalPage() {
  return <PageLayout data-id="element-1156">
      <HeaderBanner data-id="element-1157" />
      <IntroContent data-id="element-1158" />
      <KeyHighlights data-id="element-1159" />
      <CourseLength data-id="element-1160" />
      <CoursePrerequisites data-id="element-1161" />
      <CourseOverview data-id="element-1162" />
      <RegistrationCallout data-id="element-1163" />
      <CourseCosts data-id="element-1164" />
      <WhatToBring data-id="element-1165" />
      <RegistrationLinks data-id="element-1166" />
      <ContactSection data-id="element-1167" />
      <QuickLinks data-id="element-1168" />
    </PageLayout>;
}